import { Box } from '@mui/material';
import { DataCellProps } from '../types';
import { TeamStatusBadge } from '../../TeamsV2Table/DataCells/TeamsV2StatusCell';
import type { TeamStatus } from '../../TeamsV2Table/DataCells/TeamsV2StatusCell';

const getMemberStatus = (member: DataCellProps['member']): TeamStatus => {
  if (member.teamStatus === 'deleted') return { label: 'Deleted', type: 'deleted' };
  if (member.teamStatus === 'deactivated' || member.isArchived)
    return { label: 'Deactivated', type: 'deactivated' };
  return { label: 'Active', type: 'active' };
};

export const MembersV2StatusCell = ({ member }: DataCellProps) => {
  return (
    <Box>
      <TeamStatusBadge status={getMemberStatus(member)} />
    </Box>
  );
};

export default MembersV2StatusCell;
